/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Odpověď vyhodnocení daňového přiznání s varováními a informacemi o limitech
 */
export interface TaxReturnEvaluationResponseDto { 
    /**
     * Příznak zda počet parcel překračuje limit pro jeden soubor XML (nutné rozdělit)
     */
    areParcelsOverLimit?: boolean;
    /**
     * Varování zjištěná při validaci (prázdný řetězec pokud nejsou žádná varování)
     */
    warning?: string;
}

